import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useProfile } from "@/hooks/useProfile";
import { Loader2 } from "lucide-react";

const Engage = () => {
  const { user, isAuthenticated, loading } = useAuth();
  const { profile, isLoading } = useProfile();
  const navigate = useNavigate();

  // Redirect based on authentication and profile status
  useEffect(() => {
    if (!loading && !isLoading) {
      if (!isAuthenticated) {
        // Not logged in - redirect to auth
        navigate('/auth', { replace: true });
      } else if (profile?.username) {
        // Has profile - redirect to creators page
        navigate('/creators', { replace: true });
      } else {
        // No profile yet - redirect to create profile
        navigate('/create-myspai-profile', { replace: true });
      }
    }
  }, [profile, isLoading, loading, isAuthenticated, navigate]);

  // Show loading while checking auth and profile
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
};

export default Engage;
